// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"D7-z","categoryName":"E7-z","categoryImage":"F7-z","categoryContent":"G7-z","bottomAligned":"H7-z"};